// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-inputs .form-control {
  height: 40px;
}

.form-inputs .form-control:focus {
  box-shadow: none;
  border: 1px solid #000;
}

.form-control {
  min-width: 350px;
}

.search-icon {
  margin-right: 40px;
  background-color: #333742;
  padding-left: 13px;
  padding-right: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgb(210, 207, 207);
  border-radius: 16%;
  cursor: pointer;
}
.search-icon:hover {
  color: white;
  background-color: #3B71CA;
  transition: all 0.4s ease-in-out;
}

.bar-section {
  max-width: 1400px;
  background: #ffffff;
  border-radius: 3px;
  padding-left: 13px;
  padding-right: 13px;
}

.bar-section .row {
  margin: 0; /* Remove default row margin */
}

.bar-section .tab-column {
  background-color: #A4B4BF; /* Default background color */
  color: white; /* Default text color */
  cursor: pointer;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  border: 1px solid rgb(204, 202, 202);
  border-radius: 3px;
  transition: background-color 0.3s ease;
}

.bar-section .tab-column:hover {
  background-color: #6f8fa4; /* Darker shade on hover */
}

.bar-section .tab-column.active {
  background-color: #333742; /* Active tab background color */
  color: white; /* Active tab text color */
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/features/ada-access/ruleset/node-popup/node-popup.component.scss"],"names":[],"mappings":"AAGE;EACE,YAAA;AAFJ;;AAKE;EACE,gBAAA;EACA,sBAAA;AAFJ;;AAIE;EACE,gBAAA;AADJ;;AAYE;EAEE,kBAAA;EACA,yBAAA;EAEA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAXJ;AAaI;EACI,YAAA;EACA,yBAAA;EACA,gCAAA;AAXR;;AAgBA;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,mBAAA;AAdJ;;AAkBE;EACE,SAAA,EAAA,8BAAA;AAfJ;;AAkBE;EACE,yBAAA,EAAA,6BAAA;EACA,YAAA,EAAA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,sCAAA;AAfJ;;AAkBE;EACE,yBAAA,EAAA,0BAAA;AAfJ;;AAkBE;EACE,yBAAA,EAAA,gCAAA;EACA,YAAA,EAAA,0BAAA;EACA,iBAAA;AAfJ","sourcesContent":[".form-inputs{\r\n    //position:relative;\r\n  }\r\n  .form-inputs .form-control{\r\n    height:40px; \r\n  }\r\n  \r\n  .form-inputs .form-control:focus{\r\n    box-shadow:none;\r\n    border:1px solid #000;\r\n  }\r\n  .form-control {\r\n    min-width: 350px;\r\n    // margin-right: 1px;\r\n  }\r\n  \r\n  .form-inputs i{\r\n   // position:absolute;\r\n   // right:35px;\r\n    //  margin-top:10px;\r\n    //  margin-right: 20px;\r\n  }\r\n  \r\n  .search-icon{\r\n    //margin-top:1px;\r\n    margin-right: 40px;\r\n    background-color: #333742; \r\n    //padding: 9px; \r\n    padding-left: 13px;\r\n    padding-right: 13px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    color: rgb(210, 207, 207);\r\n    border-radius:16%;\r\n    cursor: pointer;\r\n  \r\n    &:hover{\r\n        color: white; \r\n        background-color: #3B71CA;\r\n        transition: all 0.4s ease-in-out;\r\n    }\r\n  }\r\n  \r\n\r\n.bar-section {\r\n    max-width: 1400px;\r\n    background: #ffffff;\r\n    border-radius: 3px;\r\n    // padding: 0; /* Remove padding to eliminate extra space */\r\n    padding-left: 13px;\r\n    padding-right: 13px;\r\n    // margin-top: 20px;\r\n  }\r\n  \r\n  .bar-section .row {\r\n    margin: 0; /* Remove default row margin */\r\n  }\r\n  \r\n  .bar-section .tab-column {\r\n    background-color: #A4B4BF; /* Default background color */\r\n    color: white; /* Default text color */\r\n    cursor: pointer;\r\n    text-align: center;\r\n    padding: 10px;\r\n    font-size: 16px;\r\n    border: 1px solid rgb(204, 202, 202);\r\n    border-radius: 3px;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n\r\n  .bar-section .tab-column:hover {\r\n    background-color: #6f8fa4; /* Darker shade on hover */\r\n  }\r\n  \r\n  .bar-section .tab-column.active {\r\n    background-color: #333742; /* Active tab background color */\r\n    color: white; /* Active tab text color */\r\n    font-weight: bold;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
